import { ControlLayout } from 'components/ControlLayout';
import { LoadingModal } from 'components/response/LoadingModal';
import { NewSimulationForm } from 'components/single-form-view/simulation/NewSimulationForm';
import { RESPONSE_PATH, RESPONSE_VIEW_ERROR } from 'constants/ResponseType';
import { FormContext } from 'context/FormContext';
import { useSimulationServices } from 'hooks/useSimulationServices';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import checkIsMobile from 'utils/CheckIsMobile';
import { useFormData } from '../hooks/useFormData';

export const NewSimulationContainer = () => {
	const history = useHistory();
	const [enableButton, setEnableButton] = useState(true);
	const [showLoadingModal, setShowLoadingModal] = useState(false);
	const [formData, setformData] = useState<any>({});
	const { formatFormData, setInitialVariablesForm } = useFormData();

	const storageService = new StorageServiceImpl();

	const { getSimulation } = useSimulationServices();

	const classContainer = checkIsMobile()
		? 'portabilidad-container'
		: 'portabilidad-container card-box';

	return (
		<div className={classContainer}>
			<FormContext.Provider
				value={{
					setError: setEnableButton,
					setData: setformData,
					storage: storageService,
				}}
			>
				<LoadingModal showLoadingModal={showLoadingModal} />
				<NewSimulationForm />
				<ControlLayout
					inputError={enableButton}
					handleBackClick={() => history.goBack()}
					handleNextClick={() => {
						setShowLoadingModal(true);
						formData.downPayment = Number.parseInt(formData.downPayment);
						setformData(setInitialVariablesForm(formData));

						getSimulation(formatFormData(formData))
							.then((response) => {
								const { data } = response;								
								sessionStorage.setItem('new-simulation', JSON.stringify(data));
								const loanSimulation = JSON.parse(sessionStorage.getItem('original-simulation') as string);
								history.push(`/simulacion/?resimulation=true&${new URLSearchParams({...loanSimulation, ...formData, ...data})}`);
							})
							.catch(() => {
								history.push(`${RESPONSE_PATH}/${RESPONSE_VIEW_ERROR}/error`);
							});
							setShowLoadingModal(false);
					}}
					buttonBackName="Volver"
					buttonNextName="Simular"
				/>
			</FormContext.Provider>
		</div>
	);
};
